// extracted by mini-css-extract-plugin
export var actions = "_21-0";
export var actionsContainer = "_21-7";
export var border = "_21-1";
export var childFullHeight = "_21-f";
export var collapse = "_21-2";
export var content = "_21-a";
export var contentChild = "_21-e";
export var fullscreen = "_21-c";
export var hasLeftRadius = "_21-k";
export var headerContainer = "_21-3";
export var headerRow = "_21-5";
export var hidePadding = "_21-b";
export var navCollapsedGap = "_21-l";
export var noScrollX = "_21-m";
export var noScrollY = "_21-n";
export var noTopPadding = "_21-i";
export var optOutTopPadding = "_21-d";
export var pageMain = "_21-j";
export var pageOuter = "_21-g";
export var pagePadding = "_21-8";
export var pageScroll = "_21-9";
export var profile = "_21-o";
export var profileContainer = "_21-p";
export var profileImage = "_21-q";
export var profileMain = "_21-r";
export var profileSubtitle = "_21-t";
export var profileTitle = "_21-s";
export var showLeftPadding = "_21-h";
export var tabsPortalSlot = "_21-6";
export var tabsWrapper = "_21-4";
export var title = "_21-u";